<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="closePanel()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editRegistroForm" (ngSubmit)="submit()">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Nombre }}</mat-label>
            <textarea
              matInput
              formControlName="Nombre"
              rows="1"
              [maxlength]="20"
            ></textarea>
            <mat-hint align="end">
              {{ editRegistroForm.get("Nombre")?.value?.length || 0 }}/20
            </mat-hint>
            <mat-error *ngIf="validateFields('Nombre')">
              {{ getErrorMessage("Nombre") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{ translation.Descripcion }}</mat-label>
            <textarea
              matInput
              formControlName="Descripcion"
              rows="1"
              [maxlength]="50"
            ></textarea>
            <mat-hint align="end">
              {{ editRegistroForm.get("Descripcion")?.value?.length || 0 }}/50
            </mat-hint>
            <mat-error *ngIf="validateFields('Descripcion')">
              {{ getErrorMessage("Descripcion") }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</div>


